import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRepeatedText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M1.75 3.783a1.1 1.1 0 0 1 1.1-1.1H4.5a.55.55 0 1 1 0 1.1H2.85V16.24H4.5a.55.55 0 0 1 0 1.1H2.85a1.1 1.1 0 0 1-1.1-1.1z" />
    <path d="M5.274 5.25c-.52 0-.94.428-.94.95v.863a.78.78 0 0 0 .777.785.78.78 0 0 0 .776-.785V6.82h3.337v8.19h-.51a.78.78 0 0 0-.777.785.78.78 0 0 0 .776.785h2.574a.78.78 0 0 0 .776-.785.78.78 0 0 0-.777-.786h-.51V6.82h3.337v.243a.78.78 0 0 0 .776.785.78.78 0 0 0 .776-.785V6.2a.945.945 0 0 0-.94-.95h-9.45Z" />
    <path d="M17.15 2.683a1.1 1.1 0 0 1 1.1 1.1V16.24a1.1 1.1 0 0 1-1.1 1.1H15.5a.55.55 0 0 1 0-1.1h1.65V3.783H15.5a.55.55 0 0 1 0-1.1z" />
  </svg>
);
export default SvgRepeatedText;
